export default __webpack_public_path__ + "static/media/twitter.72036069.png";